import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog';
import './DeleteButton.css';

interface DeleteButtonProps {
  onDelete: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  title?: string;
  message?: string;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({
  onDelete,
  disabled = false,
  size = 'small',
  title = 'Delete',
  message = 'Are you sure you want to delete this item?'
}) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const deleteIcon = (
    <svg 
      width={size === 'small' ? 16 : size === 'medium' ? 20 : 24} 
      height={size === 'small' ? 16 : size === 'medium' ? 20 : 24} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9.75 17C9.33579 17 9 16.6642 9 16.25V10.75C9 10.3358 9.33579 10 9.75 10H10.25C10.6642 10 11 10.3358 11 10.75V16.25C11 16.6642 10.6642 17 10.25 17H9.75Z"/>
      <path d="M13.75 17C13.3358 17 13 16.6642 13 16.25V10.75C13 10.3358 13.3358 10 13.75 10H14.25C14.6642 10 15 10.3358 15 10.75V16.25C15 16.6642 14.6642 17 14.25 17H13.75Z"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 3C8.34315 3 7 4.34315 7 6H3.75C3.33579 6 3 6.33579 3 6.75V7.25C3 7.66421 3.33579 8 3.75 8H5V17C5 19.2091 6.79086 21 9 21H15C17.2091 21 19 19.2091 19 17V8H20.25C20.6642 8 21 7.66421 21 7.25V6.75C21 6.33579 20.6642 6 20.25 6H17C17 4.34315 15.6569 3 14 3H10ZM15 6C15 5.44772 14.5523 5 14 5H10C9.44772 5 9 5.44772 9 6H15ZM7 8V17C7 18.1046 7.89543 19 9 19H15C16.1046 19 17 18.1046 17 17V8H7Z"/>
    </svg>
  );

  return (
    <>
      <Button
        onClick={() => setShowConfirmDialog(true)}
        disabled={disabled}
        size={size}
        variant="secondary"
        className="delete-button"
      >
        <Icon icon={deleteIcon} className="button-icon" />
        <span>Delete</span>
      </Button>

      {showConfirmDialog && createPortal(
        <ConfirmationDialog
          isOpen={showConfirmDialog}
          onClose={() => setShowConfirmDialog(false)}
          onConfirm={() => {
            setShowConfirmDialog(false);
            onDelete();
          }}
          message={message}
          confirmText="Delete"
          cancelText="Cancel"
        />,
        document.body
      )}
    </>
  );
};

export default DeleteButton; 